import { render } from "./AddCategorieInfoModal.vue?vue&type=template&id=87b1727a&ts=true"
import script from "./AddCategorieInfoModal.vue?vue&type=script&lang=ts"
export * from "./AddCategorieInfoModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__